
import {auth} from "@/scripts/firebase"
import { NoticeProps } from "@/scripts/datatypes"
import EmailAuth from '@/components/EmailAuth.vue'
import { Component,Mixins} from "vue-property-decorator";
import Common from '@/mixins/common'

@Component({
  components: {
    EmailAuth
  }
})

export default class ChangePassword extends Mixins(Common) {
  notice: NoticeProps = {}

  get emailNow(){
    return this.$store.state.user.email || ''
  }
  
  mounted(){
    console.log('mounted');
  }

  async created() {
    console.trace('created')
  }

  async updateUser() {
    try{
      await auth.currentUser?.getIdToken(true)
    }catch(error) {
      //const errorCode = this.$getErrorCode(error)
    }
  }
}
